module.exports = __webpack_public_path__ + "img/6.76a9565d.png";